import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Avatar,
  Typography,
  Paper,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  useMediaQuery,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ListBulletIcon } from "@radix-ui/react-icons";
import { GlassDialog, dialogTransitionProps } from "../../../theme/theme";

export function SessionLogsDialog({
  open,
  onClose,
  theme,
  darkMode,
  sessionLogs,
  formatToIST,
}) {
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GlassDialog open={open} onClose={onClose} maxWidth="lg" fullWidth fullScreen={fullScreen} {...dialogTransitionProps}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ bgcolor: alpha(theme.palette.info.main, 0.1), width: 48, height: 48 }}>
            <ListBulletIcon color={theme.palette.info.main} />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
              Session Logs
            </Typography>
            <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary' }}>
              Complete audit trail of user activities
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} sx={{ boxShadow: 'none', border: darkMode ? '1px solid #16213A' : '1px solid #EAF0F4', bgcolor: 'transparent' }}>
          <Table sx={{ minWidth: 700 }}>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Timestamp</TableCell>
                <TableCell>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sessionLogs.map((log) => (
                <TableRow key={log.id} hover>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
                      {log.id}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>{log.username}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={log.action}
                      sx={{
                        bgcolor: alpha(theme.palette.info.main, 0.1),
                        color: 'info.main',
                        fontWeight: 600,
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary' }}>
                      {formatToIST(log.timestamp)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
                      {typeof log.details === 'object'
                        ? JSON.stringify(log.details)
                        : log.details}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </GlassDialog>
  );
}

export default SessionLogsDialog;
